// extracted by mini-css-extract-plugin
export default {"footer":"ImportErrorsModalFooter_footer__N4C4Y","buttonWrapper":"ImportErrorsModalFooter_buttonWrapper__GJXQS"};